import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { CountrySpecificSettingsResponse } from 'src/app/state-management/types/configuration.type';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({ providedIn: 'root' })
export class ConfigurationService extends BaseApiService {
	private http = inject(HttpClient);

	fetchCountrySpecificSettings() {
		return this.http
			.get<
				ResponseObjectApiInterface<CountrySpecificSettingsResponse>
			>(`${this.apiBaseUrl}/Configuration/CountrySpecificSettings`)
			.pipe(
				map((response: ResponseObjectApiInterface<CountrySpecificSettingsResponse>) => {
					return response.data;
				}),
			);
	}
}
